import {onDomReady} from "../../components/dynamic/observer";

class CompareInfoSticky {
    constructor(infoBlock) {
        this.infoBlock = infoBlock;
        this.infoBlockOffset = this.infoBlock.getBoundingClientRect().top;
        this.stickyElement = undefined;
        this.header = undefined;
        this.headerHeight = undefined;
        this.init();
    }

    init() {
        this.stickyElement = document.querySelector(`[data-compare-sticky-el]`);

        this.header = document.querySelector('[data-header]')
        this.headerHeight = this.header.offsetHeight;

        if (this.infoBlockOffset <= 0) {
            this.addSticky();
        }

        this.addListeners();
    }

    addListeners() {
        document.addEventListener('scroll', (e) => {
            this.checkSticky();
            this.updateOffsetVars();
        });

        this.checkHeader();
    }

    checkSticky() {
        if (this.infoBlockOffset <= 0) {
            this.addSticky();
        } else {
            this.removeSticky();
        }
    }

    checkHeader() {
        document.addEventListener('header-up', () => {
            if (this.infoBlockOffset <= 0) {
                this.stickyElement.style.top = `${this.headerHeight}px`;
            }
        });

        document.addEventListener('header-down', () => {
            this.stickyElement.style.top = '0';
        });
    }

    updateOffsetVars() {
        this.infoBlockOffset = this.infoBlock.getBoundingClientRect().top;
    }

    addSticky() {
        if (!this.stickyElement.classList.contains('_sticky')) {
            this.stickyElement.classList.add('_sticky');
        }
    }

    removeSticky() {
        if (this.stickyElement.classList.contains('_sticky')) {
            this.stickyElement.classList.remove('_sticky');
        }
    }
}

onDomReady(() => {
    const infoBlocks = document.querySelectorAll('[data-compare-info]');

    if (infoBlocks.length) {
        infoBlocks.forEach((infoBlock) => new CompareInfoSticky(infoBlock));
    }
})